exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".iCountUp[data-v-311aef0a] {\n  font-size: 2.8em;\n  margin: -5px 0 0 0;\n  color: #797979;\n}\n.sau-menu-content-overflow[data-v-311aef0a] {\n  overflow-y: scroll;\n  max-height: 25vh;\n}\n", ""]);

// exports
